import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {

  constructor(private configService: ConfigService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let catalog: string;
    this.configService.selectedCatalog?.subscribe(data => {
      catalog = data;
    })
    const headers = req.headers.set('catalog', catalog);
    return next.handle(req.clone({ headers }));
  }
}
